var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBirdSimpleBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 222.57 199.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#3457a6;}.cls-1{opacity:0.5;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pixelcities_elements") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.81,101.21V0S89.28,31.9,89.28,81.32s25.63,70.59,25.63,70.59H131Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.44,93.47,74.08,2.5s-21.55,46,.12,90.42,54,52.21,54,52.21l14.45-7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.53,92.19,26.63,31.36s1.74,50.77,41.25,80.47,71.81,21.94,71.81,21.94l9.66-12.85Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.12,101.91,0,81.42s23.23,45.17,71.64,55.18S146,125.79,146,125.79l3.25-15.74Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100,111.72,2,137.19S42.81,167.42,90.65,155s61.86-42.57,61.86-42.57l-4-15.55Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.13,146.83,83.37,199.38s62.12-13,72.11-52.55,5.86-62.26,25.84-62.26l40.66,1a.59.59,0,0,0,.08-1.18L164.17,76s-19.55-3-26.94,8.32S108.13,146.83,108.13,146.83Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.26,121.24,25.34,183.35S74.78,195,113.81,164.66s40-63.55,40-63.55L144,88.42Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirdSimpleBlue);
export default __webpack_public_path__ + "static/media/bird-simple-blue.9bc9aac7c0526b8ae05b5ba68da6b541.svg";
export { ForwardRef as ReactComponent };